import request from '../utils/fetch';

type TransferDataType = {
  calculateWaitQueueFlag: boolean;
  startTime: string;
  endTime: string;
  fileName: string;
  fileTypes: any[];
  fileVersions: any[];
  pageIndex?: number;
  pageSize?: number;
  storageFileId: string;
  userId: string;
};

// 获取文件类型
export const getFileTypeApi = async () => {
  return request('/transfer/v1/transferTask/sla/fileType', {
    method: 'GET',
    params: {
      t: Date.now(),
    },
  });
};
// 获取文件版本
export const getFileVersionApi = async () => {
  return request('/transfer/v1/transferTask/sla/fileVersion', {
    method: 'GET',
    params: {
      t: Date.now(),
    },
  });
};
// 获取文件版本
export const getFileListApi = async (params: any) => {
  return request('/transfer/v1/transferTask/sla/info', {
    method: 'POST',
    params: {
      t: Date.now(),
    },
    data: params,
  });
};
// 全量下载
export const downoadAllApi = async (params: any) => {
  return request(
    '/transfer/v1/transferTask/sla/download',
    {
      method: 'POST',
      params: {
        t: Date.now(),
      },
      data: params,
    },
    true,
  );
};
// 统计指标信息查询
export const getTransferTaskStatistics = async (params: TransferDataType) => {
  return request('/transfer/v1/transferTask/sla/statistics', {
    method: 'POST',
    data: params,
  });
};
// 统计table数据分页查询
export const getTransferTableData = async (params: TransferDataType) => {
  return request('/transfer/v1/transferTask/sla/page', {
    method: 'POST',
    params: {
      t: Date.now(),
    },
    data: params,
  });
};
// 获取场景类别
export const getScenarioTypeApi = async () => {
  return request('/transfer/v1/transferTask/sla/scenarioType', {
    method: 'GET',
    params: {
      t: Date.now(),
    },
  });
};
